import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CloseIcon from '@mui/icons-material/Close';
import { radius } from '../../themes/smartinventoryTheme';

// Docks above the grid when selection > 0 — never in the header, so nothing
// shifts. `countLabel` is the already-translated "{{count}} selected" text.
const BulkBar = ({ count, countLabel, actions = [], onClear }) => {
  if (!count) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: `${radius.pill}px`,
        px: 2.25,
        py: 1,
        mb: 1.5,
      }}
    >
      <CheckBoxIcon fontSize="small" />
      <Typography variant="body2" fontWeight={600} sx={{ color: 'inherit', whiteSpace: 'nowrap' }}>
        {countLabel}
      </Typography>
      {actions.map((action) => (
        <Typography
          key={action.label}
          component="button"
          onClick={action.onClick}
          variant="body2"
          fontWeight={600}
          sx={{
            color: 'inherit',
            bgcolor: 'rgba(255,255,255,0.18)',
            border: 'none',
            borderRadius: `${radius.pill}px`,
            px: 1.5,
            py: 0.75,
            cursor: 'pointer',
            font: 'inherit',
            whiteSpace: 'nowrap',
          }}
        >
          {action.label}
        </Typography>
      ))}
      <IconButton onClick={onClear} size="small" sx={{ ml: 'auto', color: 'inherit' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default BulkBar;
